import React, { useContext } from 'react';
import styled from 'styled-components';

import { AppContext } from 'src/components/app-context';

import { Lazy } from 'src/components/lazy';
import { ProductImage as ProductImageComponent } from 'src/components/product-image';
import { SkeletonMedia } from 'src/components/skeleton';

type Props = {
  lazyLoadImage: boolean;
  imageSize: number;
  imageSrc?: string | null;
  name: string;
  className?: string;
  renderWithHalo?: boolean;
};

export const ProductMedia = (props: Props) => {
  const { market = { cdn: 'https://cdn.pji.nu' } } = useContext(AppContext);

  const { lazyLoadImage, imageSize, imageSrc, name, renderWithHalo } = props;

  const fallback = `${market.cdn}/product/standard/280/0.jpg`;
  const productImage = (
    <ProductImage
      src={imageSrc}
      name={name}
      fallback={fallback}
      height={imageSize}
      width={imageSize}
      $size={`${imageSize}px`}
      className={props.className}
    />
  );
  const halo = renderWithHalo ? (
    <HaloWrapper $size={`${imageSize}px`}>
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="#001624" fillOpacity="0.06" />
      </svg>
    </HaloWrapper>
  ) : null;

  return lazyLoadImage ? (
    <Lazy
      offset={0}
      placeholder={<SkeletonMedia height={imageSize} width={imageSize} />}
    >
      {productImage}
      {halo}
    </Lazy>
  ) : (
    <>
      {productImage}
      {halo}
    </>
  );
};

type ImageProps = {
  $size: string;
};

const ProductImage = styled(ProductImageComponent)<ImageProps>`
  width: auto;
  height: 100%;
  max-height: ${p => p.$size};
  object-fit: contain;
`;

const HaloWrapper = styled.div<ImageProps>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  max-height: ${p => p.$size};
  display: flex;
  justify-content: center;
`;
